import { useNavigate, useParams } from "react-router-dom";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

import { useGrappageCancel } from "../../api/useGrappageCancel";

type Props = {
    open: boolean;
    onClose: () => void;
};

function CancelGrappageDialog({ open, onClose }: Props) {
    const navigate = useNavigate();
    const { folderId } = useParams();

    const grappageCancelQuery = useGrappageCancel();
    const handleOnConfirm = () => {
        grappageCancelQuery.mutate(folderId as string, { onSuccess: onClose });
    };
    return (
        <Dialog open={open} disableRestoreFocus>
            <DialogTitle>Réouvrir ce dossier</DialogTitle>
            <DialogContent>
                <Typography>
                    Le grappage de ce dossier est terminé, souhaitez-vous le réouvrir ?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => navigate(-1)}>Retour</Button>
                <Button onClick={handleOnConfirm}>Confirmer</Button>
            </DialogActions>
        </Dialog>
    );
}

export default CancelGrappageDialog;
